import EventAttribute from '../../../event-attribute';
import constants from './constants';
import glossary from './glossary';

export default class AssociationFeatureValue extends EventAttribute {
  constructor(item = {}, url) {
    super(item, url);
    this.event_association_feature_id = item.event_association_feature_id;

    this.created_at = item.created_at;
    this.updated_at = item.updated_at;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
